/**
 * 
 * @authors Your Name (you@example.org)
 * @date    2019-12-24 17:24:11
 * @version $Id$
 */

import Cookies from 'js-cookie'

export function getLang() {
  return localStorage.getItem('Language')
}




// WEBPACK FOOTER //
// ./src/utils/config.js